/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * desakita API — permukaan publik
 * Dokumen TURUNAN — JANGAN diedit. Dihasilkan scripts/gen-public-spec.ts dari dist/openapi.bundled.yaml, memuat HANYA operasi ber-`security: []`. Untuk mengubah isinya, ubah kontraknya (openapi/features/*.yaml) lalu daftarkan operationId-nya di openapi/_shared/public-operations.yaml.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FailureResponse,
  PendudukPublicStatistikAgamaResponse,
  PendudukPublicStatistikPekerjaanResponse,
  PendudukPublicStatistikPendidikanResponse,
  PendudukPublicStatistikResponse,
  SuccessEnvelope
} from '../../model';

import { publicFetch } from '../../../mutator/publicFetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPublicPendudukStatistikUrl = () => {




  return `/public/penduduk/statistik`
}

export const getPublicPendudukStatistik = async ( options?: RequestInit): Promise<SuccessEnvelope & PendudukPublicStatistikResponse> => {

  return publicFetch<SuccessEnvelope & PendudukPublicStatistikResponse>(getGetPublicPendudukStatistikUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPendudukStatistikQueryKey = () => {
    return [
    `/public/penduduk/statistik`
    ] as const;
    }


export const getGetPublicPendudukStatistikQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPendudukStatistikQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPendudukStatistik>>> = ({ signal }) => getPublicPendudukStatistik({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicPendudukStatistikQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPendudukStatistik>>>
export type GetPublicPendudukStatistikQueryError = FailureResponse


export function useGetPublicPendudukStatistik<TData = Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistik>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistik>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistik<TData = Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistik>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistik>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistik<TData = Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicPendudukStatistik<TData = Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistik>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicPendudukStatistikQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicPendudukStatistikAgamaUrl = () => {




  return `/public/penduduk/statistik/agama`
}

export const getPublicPendudukStatistikAgama = async ( options?: RequestInit): Promise<SuccessEnvelope & PendudukPublicStatistikAgamaResponse> => {

  return publicFetch<SuccessEnvelope & PendudukPublicStatistikAgamaResponse>(getGetPublicPendudukStatistikAgamaUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPendudukStatistikAgamaQueryKey = () => {
    return [
    `/public/penduduk/statistik/agama`
    ] as const;
    }


export const getGetPublicPendudukStatistikAgamaQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPendudukStatistikAgamaQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>> = ({ signal }) => getPublicPendudukStatistikAgama({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicPendudukStatistikAgamaQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>>
export type GetPublicPendudukStatistikAgamaQueryError = FailureResponse


export function useGetPublicPendudukStatistikAgama<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistikAgama<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistikAgama<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicPendudukStatistikAgama<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikAgama>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicPendudukStatistikAgamaQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicPendudukStatistikPekerjaanUrl = () => {




  return `/public/penduduk/statistik/pekerjaan`
}

export const getPublicPendudukStatistikPekerjaan = async ( options?: RequestInit): Promise<SuccessEnvelope & PendudukPublicStatistikPekerjaanResponse> => {

  return publicFetch<SuccessEnvelope & PendudukPublicStatistikPekerjaanResponse>(getGetPublicPendudukStatistikPekerjaanUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPendudukStatistikPekerjaanQueryKey = () => {
    return [
    `/public/penduduk/statistik/pekerjaan`
    ] as const;
    }


export const getGetPublicPendudukStatistikPekerjaanQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPendudukStatistikPekerjaanQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>> = ({ signal }) => getPublicPendudukStatistikPekerjaan({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicPendudukStatistikPekerjaanQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>>
export type GetPublicPendudukStatistikPekerjaanQueryError = FailureResponse


export function useGetPublicPendudukStatistikPekerjaan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistikPekerjaan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistikPekerjaan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicPendudukStatistikPekerjaan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPekerjaan>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicPendudukStatistikPekerjaanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPublicPendudukStatistikPendidikanUrl = () => {




  return `/public/penduduk/statistik/pendidikan`
}

export const getPublicPendudukStatistikPendidikan = async ( options?: RequestInit): Promise<SuccessEnvelope & PendudukPublicStatistikPendidikanResponse> => {

  return publicFetch<SuccessEnvelope & PendudukPublicStatistikPendidikanResponse>(getGetPublicPendudukStatistikPendidikanUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicPendudukStatistikPendidikanQueryKey = () => {
    return [
    `/public/penduduk/statistik/pendidikan`
    ] as const;
    }


export const getGetPublicPendudukStatistikPendidikanQueryOptions = <TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError = FailureResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicPendudukStatistikPendidikanQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>> = ({ signal }) => getPublicPendudukStatistikPendidikan({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicPendudukStatistikPendidikanQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>>
export type GetPublicPendudukStatistikPendidikanQueryError = FailureResponse


export function useGetPublicPendudukStatistikPendidikan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError = FailureResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistikPendidikan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>,
          TError,
          Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>
        > , 'initialData'
      >, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicPendudukStatistikPendidikan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicPendudukStatistikPendidikan<TData = Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError = FailureResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicPendudukStatistikPendidikan>>, TError, TData>>, request?: SecondParameter<typeof publicFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicPendudukStatistikPendidikanQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






